// removed by extract-text-webpack-plugin
module.exports = {"bg":"_1tuUw","base":"_3Roi3","sectionHeader":"_3D9kb","title":"_25rox","content":"_3U76M","spinner":"_2OCFw","list":"_2xRwo","form":"PXhVy","group":"_1nzV6","footer":"_16RJ8"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PersonalInfo/PartnerChildrenDisplayForm.scss
// module id = 1939
// module chunks = 0